import { IonContent, IonHeader, IonPage, IonTitle, IonToolbar, IonButton, IonList, IonItem, IonLabel, IonGrid, IonRow, IonCol, IonModal, IonIcon, IonChip, IonInput } from '@ionic/react';
import { closeCircle } from 'ionicons/icons';
import React, { useState } from 'react';
import SelectItem from './SelectItem';
import { EnquiryStatus } from '../services/enquiry.service';

interface IProps {
    filter: any;
    filterChangeHandler: Function;
    onDoneHandler: Function;
    onCloseHandler: Function;
}

const STATUS_OPTIONS = [
    { label: 'New', value: EnquiryStatus.NEW },
    { label: 'Open', value: EnquiryStatus.OPEN },
    { label: 'Purchased', value: EnquiryStatus.PURCHASED },
    { label: 'Not Purchased', value: EnquiryStatus.NOT_PURCHASED },
];

const EnquiryFilter: React.FC<IProps> = (props) => {
    const [selectedStatus, setSelectedStatus] = useState<string>(props?.filter?.status || '');
    const [mobileFilter, setMobileFilter] = useState<string>(props?.filter?.mobile || '');
    const [nameFilter, setNameFilter] = useState<string>(props?.filter?.name || '');
    const [locationFilter, setLocationFilter] = useState<string>(props?.filter?.location || '');
    const [showSelectStatusModal, setShowSelectStatusModal] = useState(false);

    function onDone() {
        const and: any[] = [];
        if (selectedStatus) and.push({ status: selectedStatus });
        if (mobileFilter.trim()) and.push({ mobile: { like: `.*${mobileFilter.trim()}.*`, options: 'i' } });
        if (nameFilter.trim()) and.push({ name: { like: `.*${nameFilter.trim()}.*`, options: 'i' } });
        if (locationFilter.trim()) and.push({ location: { like: `.*${locationFilter.trim()}.*`, options: 'i' } });

        props.filterChangeHandler({
            status: selectedStatus,
            mobile: mobileFilter,
            name: nameFilter,
            location: locationFilter,
        });
        props.onDoneHandler(and.length ? { and } : {});
        onClose();
    }

    function onReset() {
        setSelectedStatus('');
        setMobileFilter('');
        setNameFilter('');
        setLocationFilter('');
        props.filterChangeHandler({});
        props.onDoneHandler({});
        onClose();
    }

    function onClose() {
        props.onCloseHandler(false);
    }

    return (
        <IonPage>
            <IonHeader>
                <IonToolbar>
                    <IonTitle>Filter</IonTitle>
                </IonToolbar>
            </IonHeader>
            <IonContent fullscreen>
                <IonList>
                    <IonItem lines="none">
                        <IonLabel>Status</IonLabel>
                    </IonItem>
                    <IonItem>
                        <IonGrid>
                            <IonRow onClick={() => setShowSelectStatusModal(true)}>
                                {selectedStatus ? (
                                    <IonCol>
                                        <IonChip outline={true} color="primary">
                                            <IonLabel>{STATUS_OPTIONS.find(o => o.value === selectedStatus)?.label}</IonLabel>
                                            <IonIcon
                                                icon={closeCircle}
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    setSelectedStatus('');
                                                }}
                                            />
                                        </IonChip>
                                    </IonCol>
                                ) : (
                                    <IonCol>
                                        <IonLabel style={{ color: 'var(--ion-color-medium)' }}>Select Status</IonLabel>
                                    </IonCol>
                                )}
                            </IonRow>
                        </IonGrid>
                    </IonItem>

                    <IonItem>
                        <IonLabel position="stacked">Mobile Number</IonLabel>
                        <IonInput
                            value={mobileFilter}
                            placeholder="Filter by mobile number"
                            onIonChange={(e) => setMobileFilter(e.detail.value || '')}
                        />
                    </IonItem>

                    <IonItem>
                        <IonLabel position="stacked">Farmer Name</IonLabel>
                        <IonInput
                            value={nameFilter}
                            placeholder="Filter by farmer name"
                            onIonChange={(e) => setNameFilter(e.detail.value || '')}
                        />
                    </IonItem>

                    <IonItem>
                        <IonLabel position="stacked">Location</IonLabel>
                        <IonInput
                            value={locationFilter}
                            placeholder="Filter by location"
                            onIonChange={(e) => setLocationFilter(e.detail.value || '')}
                        />
                    </IonItem>
                </IonList>

                <IonGrid>
                    <IonRow>
                        <IonCol><IonButton color="danger" style={{ float: 'right' }} onClick={onReset}>Reset</IonButton></IonCol>
                        <IonCol><IonButton onClick={onDone}>Done</IonButton></IonCol>
                    </IonRow>
                </IonGrid>

                {showSelectStatusModal && (
                    <IonModal isOpen={showSelectStatusModal}>
                        <SelectItem
                            label="Select Status"
                            items={STATUS_OPTIONS}
                            labelKey="label"
                            valueKey="value"
                            hideSearchbar
                            setItem={(item: any) => {
                                setSelectedStatus(item.value);
                                setShowSelectStatusModal(false);
                            }}
                            selectedValue={selectedStatus}
                            onClose={setShowSelectStatusModal}
                        />
                    </IonModal>
                )}
            </IonContent>
        </IonPage>
    );
};

export default EnquiryFilter;
